import React, { useState, useEffect } from 'react'

import { LuchoFestGame } from './LuchoFest/LuchoFestGame'

import imgBrand from '../../../assets/games/luchoFest/brand.png'

// 2. ASIGNAMOS LAS VARIABLES IMPORTADAS A NUESTRO OBJETO
const GAME_ASSETS = {
    BRAND: imgBrand
}

/**
 * Componente LuchoFest (Padre)
 * Gestiona el montaje del juego y los resultados.
 */
const LuchoFest = ({ 
    isPracticeRoundParameter = false, 
    userZoneParameter = 'Mobil', 
    winningZoneParameter = 'Mobil',
    gameSequence = [],
    emergencyTrigger = 0
}) => {
    const [currentContainerStep, setCurrentContainerStep] = useState('game_active'); //game_active
    const [finalObtainedScore, setFinalObtainedScore] = useState(0);

    // --- NUEVO: ESCUCHADOR DE EMERGENCIA ---
    // Si el Admin presiona el botón, este valor cambiará y forzaremos el salto a la pantalla final.
    useEffect(() => {
        if (emergencyTrigger > 0) {
            setCurrentContainerStep('final_results_screen');
        }
    }, [emergencyTrigger]);

    const executePostGameSequence = async (scoreReceivedFromGame) => {
        setFinalObtainedScore(scoreReceivedFromGame);
        setCurrentContainerStep('showing_modal_score');
        await new Promise(resolveTime => setTimeout(resolveTime, 3000));
        setCurrentContainerStep('final_results_screen');
    };

    const containerOverflowBehavior = currentContainerStep === 'final_results_screen' ? 'auto' : 'hidden';

  return (
    <div>
        {currentContainerStep === 'game_active' && (
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100dvh', overflow: containerOverflowBehavior, zIndex: 9999, backgroundColor: '#f3f4f6' }}>
                <LuchoFestGame
                    onGameFinishEvent={executePostGameSequence}
                    gameSequence={gameSequence} // Le pasamos la secuencia al motor
                />
            </div>
        )}

        {currentContainerStep === 'showing_modal_score' && (
            <div className="lucho-fest__overlay lucho-fest__overlay--dark">
                <div className="lucho-fest__result-card">
                    <h2 className="lucho-fest__title" style={{ color: '#ea580c' }}>¡TIEMPO!</h2>
                    <div className="lucho-fest__score-display">{finalObtainedScore}</div>
                    <p className="lucho-fest__subtitle">Puntuación Final</p>
                    <p style={{ fontWeight: 'bold', color: '#9ca3af', marginTop: '1rem' }}>¡Espera! Estamos calculando...</p>
                </div>
            </div>
        )}

        {currentContainerStep === 'final_results_screen' && (
            <div className='SelfieFan__Sent container'>
                {userZoneParameter === winningZoneParameter ? (
                    <>
                        <p className='SelfieFan__Sent__Title mb-0'>¡Felicidades!</p>
                        <p className='mb-0'>Ha ganado tu zona</p>
                    </>
                ) : (
                    <p>Ha ganado la zona {winningZoneParameter.toUpperCase()}</p>
                )}
                
                {isPracticeRoundParameter ? (
                    <>
                        <p className=''>Esta fue una ronda de prueba</p>
                        <p className=''>¿Estás list@ para la ronda real?</p>
                        <p className=''>No salgas de esta pantalla</p>
                    </>
                ) : (
                    <>
                        {userZoneParameter === winningZoneParameter && (
                            <>
                                <p className=''>Tienes una promo de BBY mix por solo $100 MXN</p>
                                <img src={GAME_ASSETS.BRAND} alt="Logotipo BBY" className='mx-auto' style={{ width: '100%', maxWidth: '150px' }} />
                                <p className='small'>Válido solo hoy 26 de Febrero del 2026</p>
                            </>
                        )}
                    </>
                )}

                <hr />
                
                <a href='https://fivedigitalminds.com/?utm_source=luchoFest_web&utm_medium=banner&utm_campaign=fdm_adsl' target='_blank' rel="noreferrer" className='SelfieFan__Sent__Banner'>
                    <img src='/img/advertising/fdm/banner/five-digital-minds-agradecimiento.gif' alt='Publicidad' className='d-block m-auto SelfieFan__Sent__Banner__Image' />
                </a>
                <a href='https://fivedigitalminds.com/?utm_source=luchoFest_web&utm_medium=banner&utm_campaign=fdm_adsl' target='_blank' rel="noreferrer" className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center d-block'>Contactar ahora</a>

                <hr />

                <p className='text-center mb-0'>¿Quieres conocer más de esta tecnología?</p>
                <p className='text-center mb-0'>Five Digital Minds está listo para ti</p>
                <a href='https://fivedigitalminds.com/?utm_source=luchoFest_web&utm_medium=banner_text&utm_campaign=fdm_adsl' target='_blank' className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center'>Contactar ahora</a>
            </div>
        )}
    </div>
  );
};

export { LuchoFest };